export default {
  msgManage: 'Message Preferences',
  noOne: 'No Messages',
  everyone: 'Messages from Everyone',
  blacklist: 'Messages Except Blocked (Manage List)',
  remove: 'Remove',
  blackListTips: 'The Blocked List is only available when “Messages Except Blocked” is selected. Switching to another option won’t remove the users you’ve blocked.',
  openReceive: 'Receive Messages',
  closeReceive: 'Block Messages',
  setting: 'Settings',
  needAuthForChat: 'This member has changed their DM settings. You can message them if they update their preferences.',
  uploadFail: 'Upload fail, please try again'
}